<template>
  <div class="w-screen h-screen | flex | bg-grey-100 overflow-visible">
    <NavBar />
    <div class="main__container grow overflow-auto">
      <main class="py-10 pl-10 | min-h-[calc(100%-9.125rem)]"><slot /></main>
      <Footer />
    </div>
  </div>
  <ToastMultiDownload />
</template>
